import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/Home.vue'
import Introduce from '../pages/introduce/index.vue'


Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {title:'城际拼车-光彩出行'},
  },
  {
    path: '/introduce',
    name: 'Introduce',
    component:Introduce  ,// () => import('../pages/introduce/index.vue'),
    meta: {title:'产品详情'},
  },
  {
    path: '/orderReceiving',
    name: 'OrderReceiving',
    component:() => import('../views/orderReceiving/index.vue'),
    meta: {title:'等待司机接单'},
  },
  {
    path:'/location',
    name:"Location",
    component:()=>import ('../views/location/index.vue'),
    meta:{title:'城际拼车'}
  },
  {
    path:'/driver/orderReceiving',
    name:'order',
    component:()=>import('../views/driver-orderReceiving/index.vue'),
    meta:{title:'司机已接单'}
  },
  {
    path:'/errorinfo',
    name:'Errorinfo',
    component:()=>import('../views/404.vue'),
    meta:{title:'页面出错了'}
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
